import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import classes from './JobCard.module.scss';
import { ContractIcon, LocationV2Icon, BookmarkIcon } from '../../../common/Icons';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeJobs } from '../../../../utils/constants';
import { getFullLocationString } from '../../../../utils/helpers';
import { loginRequest } from '../../../../authConfig';
import { saveJob, removeSavedJob } from '../../../../actions/jobs';
import { subTabs, tabs } from '../../../../Routes/jobs/jobTabs';

const JobCard = ({ job, clickHandler, isActive = false, tabTypes }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { width } = useWindowSize();
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();
  const userId = localStorage.getItem('UserId');

  const getStatusLabel = () => {
    const isAppliedCheck = tabTypes.subTab === subTabs.APPLIED ? job?.UIName : job.IsApplied;
    const isOpenCheck = tabTypes.subTab === subTabs.APPLIED ? job?.UIName : !job.IsOpen;
    if (isAppliedCheck)
      return <div className={`${classes.statusWrapper} ${classes.applied}`}>{t('common.general.applied')}</div>;
    if (isOpenCheck)
      return <div className={`${classes.statusWrapper} ${classes.closed}`}>{t('common.general.closed')}</div>;
    return undefined;
  };

  const saveHandler = (e) => {
    e.stopPropagation();

    if (isAuthenticated && width <= responsiveSizeJobs) {
      dispatch(
        job?.IsSaved
          ? removeSavedJob(
              job.Id,
              searchParams.get('subTab') === subTabs.SAVED && searchParams.get('tab') === tabs.MY_JOBS
            )
          : saveJob(
              job.Id,
              userId,
              searchParams.get('subTab') === subTabs.SAVED && searchParams.get('tab') === tabs.MY_JOBS
            )
      );
    } else {
      localStorage.setItem('saveJobAfterLogin', JSON.stringify(job.Id));
      instance
        .loginRedirect({
          ...loginRequest,
          redirectUri: `${window.location.origin}/dashboard/jobs`,
          state: JSON.stringify({ navigate: `/dashboard/jobs/${job.Id}` })
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <div
      role="presentation"
      className={`${classes.cardContainer} ${isActive && width > responsiveSizeJobs ? classes.active : ''}`}
      onClick={clickHandler}
    >
      <p className={classes.title}>{job.JobTitle}</p>
      <div className={classes.status}>
        {getStatusLabel()}
        {job.IsSaved && width > responsiveSizeJobs && <BookmarkIcon filled height="20" />}
        {width <= responsiveSizeJobs && (
          <div role="presentation" onClick={saveHandler}>
            <BookmarkIcon filled={job.IsSaved} height="18" />
          </div>
        )}
      </div>
      <div className={classes.location}>
        <LocationV2Icon
          width={width > responsiveSizeJobs ? '15' : '10'}
          height={width > responsiveSizeJobs ? '20' : '14'}
        />
        {getFullLocationString(job.City, job.State, job.Country)}&nbsp;(
        {job.RemotePosition ? t('dashboard.jobs.card.remote') : t('dashboard.jobs.card.onsite')})
      </div>
      <div className={classes.type}>
        <ContractIcon
          width={width > responsiveSizeJobs ? '15' : '10'}
          height={width > responsiveSizeJobs ? '20' : '14'}
        />
        {job.JobType}
      </div>
    </div>
  );
};

export default JobCard;
